import styled from "styled-components";
import theme from "~/styles/theme";

export const CoupomHolder = styled.div`
  background-color: ${theme.palette.neutral.primary.light};
  border-radius: 16px;
  display: flex;
  overflow: hidden;
  flex-direction: column;

  @media (min-width: ${theme.breakpoints.values.md}px) {
    flex-direction: row;
  }
`;

export const CoupomData = styled.div`
  padding: 32px 46px;
  text-align: center;

  p {
    font-size: 18px;
  }

  img {
    margin-bottom: 24px;

    @media (min-width: ${theme.breakpoints.values.md}px) {
      margin-bottom: 32px;
    }
  }
`;

export const Image = styled.div`
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top center;
  width: 100%;
  height: 138px;
  display: flex;
  flex: 1;

  @media (min-width: ${theme.breakpoints.values.md}px) {
    width: 262px;
    min-height: 396px;
    height: 100%;
    flex: 0 0 auto;
  }
`;

export const Code = styled.div`
  width: 100%;
  height: 55px;
  background-color: ${theme.palette.neutral.primary.medium};
  color: ${theme.palette.neutral.primary.key};
  padding: 15px 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  font-weight: 500;

  svg {
    cursor: pointer;
    margin-left: 20px;
  }

  img {
    margin-bottom: -20px;
  }
`;

export const CopiedMessage = styled.span`
  font-size: 12px;
  padding: 16px 0;
  color: ${theme.palette.feedback.success.key};
  display: block;
`;
